<template>
    <div>
        <Teleport to="#guest_actions">
            <v-spacer/>
            <v-btn test-tag="tag-67" class="mr-4" color="primary" @click="createGuestHandler('many')">Создать и добавить еще</v-btn>
            <v-btn test-tag="tag-68" color="primary" @click="createGuestHandler('one')">Создать</v-btn>
        </Teleport>
        <v-card-text class="mt-2">
            <v-container>
                <v-form ref="new_guest">
                    <v-row dense>
                        <v-col cols="6">
                            <EditableInfoField
                                fake_hint
                                :label="$t('Телефон для связи с гостем')"
                                :value="guest.phone.number" 
                                @focus.prevent="e => $store.dispatch('inputFocus', e)"
                                kbd-layout="numpad"
                                ref="guest_phone_field"
                                :rules="[rules.required, rules.phoneRule]"
                            >
                            <template #editor="{blurEditable, setEditable}">
                                <PhoneField 
                                    v-bind="{...$attrs, value: null}" 
                                    v-on="{...$listeners, input: null}"
                                    :rules="[rules.required, rules.phoneRule]"
                                    v-model="guest.phone.number"
                                    append-outer-icon="mdi-check"
                                    :label="$t('Телефон для связи с гостем')" 
                                    kbd-layout="numpad"
                                    kbd-no-caret
                                    ref="editor"

                                    @focus.prevent="setEditable(true)"

                                    @click:append-outer="blurEditable"
                                />
                            </template>
                            </EditableInfoField>
                            <EditableInfoField ref="guest_name_field" fake_hint @focus.prevent="e => $store.dispatch('inputFocus', e)" kbd-capitalized :label="$t('ФИО гостя')" v-model="guest.name" :rules = "[rules.required, rules.nameRule(2)]"/>
                        </v-col>
                        <v-col cols="6">
                            <EditableInfoField ref="guest_email_field" fake_hint kbd-layout="en_US_qwerty" @focus.prevent="e => $store.dispatch('inputFocus', e)" :label="$t('Адрес электронной почты')" v-model="guest.email" :rules = "[rules.emailRule]"/>
                            <EditableInfoField fake_hint @focus.prevent="e => $store.dispatch('inputFocus', e)" :label="$t('Информация о госте')" v-model="guest.extra"/>
                        </v-col>
                        <v-col cols="12">
                            <SelectField fake_hint item-value="code" :label="$t('Спец.скидка гостя')" :items="guest_discounts" style="min-height: 85px;" v-model="guest.discount"/>
                        </v-col>
                        <v-col cols="12">
                            <InlineAddressAppenderField ref="guest_address_field" v-model="guest.address"/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
import Teleport from 'vue2-teleport'
import InlineAddressAppenderField from '@/components/orders/new_order/NewOrderInfo/InlineAddressAppenderField.vue'
import EditableInfoField from '@/components/common/EditableInfoField.vue'
import SelectField from '../common/SelectField.vue';
import rules_mixin from '@/components/common/rules_mixin'
import PhoneField from '../common/PhoneField.vue';
import {mapGetters, mapActions} from 'vuex'

export default{
    mixins: [rules_mixin],
    data: () => ({
        guest: {
            name: "",
            address: {},
            phone: {number: ""},
            email: '',
            extra: '',
            discount: null
        },
        lastLocalPhone: undefined,
        loading: false,
    }),
    computed: {
        ...mapGetters(['references', 'guest_discounts']),
    },
    methods: {
        ...mapActions(['throwTimeoutMessage', 'createGuest']),
        checkFields(){
            if(!(this.$refs.guest_phone_field.isValid && this.guest.phone.number.length > 0)){
                this.throwTimeoutMessage({
                    message_data: 'Неверно указан или не задан номер телефона', 
                    message_class: 'error'
                })
                return false
            }
            if(!(this.$refs.guest_name_field.isValid && this.guest.name.length > 0)){
                this.throwTimeoutMessage({
                    message_data: 'Неверно указано или не задано ФИО', 
                    message_class: 'error'
                })
                return false
            }
            if(!this.$refs.guest_email_field.isValid){
                this.throwTimeoutMessage({
                    message_data: 'Неверно указан email', 
                    message_class: 'error'
                })
                return false
            }

            return true
        },
        async createGuestHandler(type){
            if(!this.checkFields()) return
            try{
                await this.createGuest(this.guest)
                if(type === 'one') this.$router.push('/guests')
                else {
                    this.guest = { 
                        name: "", address: {value: null}, phone: { number: "" }, 
                        email: "", extra: "", discount: null
                    }
                    this.$refs.guest_address_field.search_query = ""
                }
                this.throwTimeoutMessage({
                    message_data: 'Гость успешно добавлен',
                    message_class: 'success'
                })
            }
            catch(e){
                return
            }
        },

        makeEditable() {
            this.guest.phone = {number: ''}
            this.$refs.guest_phone_field.makeEditable()
            this.focus()
        },

        rollbackEdit() {
            if (!this.lastLocalPhone?.number) {
                this.lastLocalPhone = undefined
                this.$emit('input', this.default ? this.default : this.items[0])
            }
            this.$refs.guest_phone_field.blurEditable()
        },
    },
    components: {
        EditableInfoField,
        InlineAddressAppenderField,
        PhoneField,
        SelectField,
        Teleport
    }
}
</script>